export default function ymrsScoreDescription(number: number): string {
  let description;
  if (number >= 21) {
    description = "manie";
  }
  if (number >= 12 && number < 21) {
    description = "hypomanie";
  }
  if (number < 12) {
    description = "pas d'hypomanie";
  }

  return description;
}
